<template>
    <div>
        <div class="mx-3 rounded-lg bg-primary px-4 py-3 mt-3 mb-1">
            <p class="text-small user-select-none text-white font-weight-medium">{{ `${$auth.user.first_name ? $auth.user.first_name : ''} ${$auth.user.last_name ? $auth.user.last_name : ''}${!$auth.user.first_name && !$auth.user.last_name ? 'بدون نام': ''}` }}</p>
            <p class="text-small user-select-none text-white">{{ $auth.user.full_admin ? 'مدیر ارشد' : $auth.user.branch_admin ? 'سرپرست شعبه' : $auth.user.department_admin ? 'سرپرست دپارتمان' : $auth.user.employee ? 'کارشناس' : ($auth.user.customer_information && $auth.user.customer_information.supervisor && Object.hasOwn($auth.user, 'organization') ? `سرپرست ${$auth.user.organization}` : Object.hasOwn($auth.user, 'organization') ? $auth.user.organization : 'مشتری') }}</p>
        </div>
        <div class="px-3">
            <v-list class="mt-0">
                <v-list-item @click="$router.push({path: '/editProfile'})" class="cursor-pointer">
                    <template #prepend>
                        <v-icon size="20" class="me-n4 opacity-100" color="secondary">icon-settings</v-icon>
                    </template>
                    <v-list-item-title class="text-small text-grey-darken-1 font-weight-medium">
                        ویرایش پروفایل
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="$router.push({path: '/editProfile'})" class="cursor-pointer">
                    <template #prepend>
                        <v-icon size="20" class="me-n4 opacity-100" color="secondary">icon-secretary</v-icon>
                    </template>
                    <v-list-item-title class="text-small text-grey-darken-1 font-weight-medium">
                        تنظیمات کلمه عبور
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('logout')" class="cursor-pointer">
                    <template #prepend>
                        <v-icon size="20" class="me-n4 opacity-100" color="error">icon-power</v-icon>
                    </template>
                    <v-list-item-title class="text-small text-grey-darken-1 font-weight-medium">
                        خروج
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>
<script></script>
